export default __webpack_public_path__ + "static/media/comments.ad6042d6.png";